<template>

  <div>
    <div v-for="(result, name) in definition.results" :key="name">
      <monitoring-result :name="name" :values="values[name] || []" :previous="previous[name] || []"></monitoring-result>
    </div>
  </div>

</template>

<script>
  import MonitoringResult from './monitoring-result'

  export default {
    name: 'state-active',

    props: [ 'definition', 'values', 'previous' ],

    components: {
      MonitoringResult
    }
  }
</script>

<style scoped lang="scss">

</style>
